import { styled, Switch } from "@mui/material";
import { adjustColor } from "utils";

const StyledSwitch = styled(Switch, {
  shouldForwardProp: (prop) => prop !== "onLabel" && prop !== "offLabel",
})(({ theme, onLabel, offLabel, checked }) => {
  const hasOnLabel = typeof onLabel === "string" && onLabel.trim() !== "";
  const hasOffLabel = typeof offLabel === "string" && offLabel.trim() !== "";
  const isLabel = hasOnLabel && hasOffLabel;
  // Determine the longest label length
  const maxLabelLength = Math.max(
    isLabel ? onLabel.length : 0,
    isLabel ? offLabel.length : 0
  );

  // Compute dynamic width: base 50px + 6px per character, capped minimum at 50
  const dynamicWidth = Math.max(50, 28 + maxLabelLength * 7);

  const width = isLabel ? dynamicWidth : 36;
  const height = isLabel ? 30 : 20;
  const thumbHW = isLabel ? 26 : 16;

  const onBackGround = isLabel ? adjustColor("#027A48", 45) : "#101828";
  const offBackGround = isLabel
    ? adjustColor("#B42318", 45)
    : "rgba(0,0,0,.25)";

  return {
    width,
    height,
    padding: 0,
    display: "flex",
    position: "relative",
    "--onLabel": hasOnLabel ? `"${onLabel}"` : '""',
    "--offLabel": hasOffLabel ? `"${offLabel}"` : '""',

    "& .MuiSwitch-switchBase": {
      padding: 2,
      "& .MuiSwitch-input": {
        width,
        left: 0,
      },
      "&.Mui-checked": {
        transform: `translateX(${width - (height - 1)}px)`,
        color: "#fff",
        "& .MuiSwitch-input": {
          left: `calc((${width}px - ${thumbHW + 2}px) * -1)`,
        },

        "& + .MuiSwitch-track": {
          opacity: 1,
          backgroundColor: onBackGround,
          ...theme.applyStyles?.("dark", {
            backgroundColor: "#177ddc",
          }),
          ...(hasOnLabel && {
            "&::before": {
              content: "var(--onLabel)",
              position: "absolute",
              left: "8px",
              top: "50%",
              transform: "translateY(-50%)",
              fontSize: 11,
              fontWeight: 600,
              color: "#fff",
              zIndex: 1,
              whiteSpace: "nowrap",
            },
          }),
        },
      },
    },

    "& .MuiSwitch-thumb": {
      boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
      width: thumbHW,
      height: thumbHW,
      borderRadius: "50%",
      backgroundColor: "#fff",
      transition: theme.transitions.create(["transform"], {
        duration: 200,
      }),
      zIndex: 2,
    },

    "& .MuiSwitch-track": {
      position: "relative",
      borderRadius: 30 / 2,
      opacity: 1,
      backgroundColor: offBackGround,
      boxSizing: "border-box",
      ...theme.applyStyles?.("dark", {
        backgroundColor: "rgba(255,255,255,.35)",
      }),
      ...(hasOffLabel && {
        "&::before": {
          content: "var(--offLabel)",
          position: "absolute",
          right: "8px",
          top: "50%",
          transform: "translateY(-50%)",
          fontSize: 11,
          fontWeight: 600,
          color: "#fff",
          zIndex: 1,
          whiteSpace: "nowrap",
        },
      }),
    },
  };
});

export default StyledSwitch;
